import type { StyleLayer } from './utils/types'

export const layers_parkingLars_areas: StyleLayer[] = [
  {
    id: 'background colour',
    type: 'fill',
    filter: ['match', ['get', 'amenity'], ['bicycle_parking'], false, true],
    paint: {
      'fill-color': [
        'case',
        ['match', ['get', 'parking'], ['multi-storey'], true, false],
        'rgb(233, 91, 84)',
        ['match', ['get', 'parking'], ['underground'], true, false],
        'rgb(142, 192, 169)',
        ['match', ['get', 'parking'], ['carports', 'carport'], true, false],
        'rgb(251, 206, 74)',
        ['match', ['get', 'building'], ['garages', 'garage', 'carport'], true, false],
        'rgb(251, 206, 74)',
        'rgb(48, 159, 219)',
      ],
    },
  },
  {
    id: 'stripe pattern',
    type: 'fill',
    filter: ['match', ['get', 'amenity'], ['bicycle_parking'], false, true],
    paint: {
      'fill-color': 'rgba(0, 0, 0, 0)',
      'fill-opacity': 0.5,
      'fill-pattern': ['match', ['get', 'access'], ['customers', 'private'], 'pattern-stripes', ''],
    },
  },
  {
    id: 'capacity label',
    type: 'symbol',
    filter: ['match', ['get', 'amenity'], ['bicycle_parking'], false, true],
    layout: {
      'text-field': ['to-string', ['get', 'capacity']],
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 14.99, 0, 15, 9, 20, 20],
    },
    paint: {
      'text-color': 'rgb(255, 255, 255)',
      'text-halo-color': 'rgba(0, 0, 0, 0.33)',
      'text-halo-width': 0.5,
    },
  },
]
